export default class MassiaSelectService {
	static $inject = ['$http', 'moment'];

	constructor($http, moment) {
		this.$http = $http;
		this.moment = moment;
	}

	async getOneByTypeAndId(type, id) {
		let url = `${__configuration.apiUrl}/massia-select/${type}/${id}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getSocietesCom() {
		let url = `${__configuration.apiUrl}/massia/societes-commerciales`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getSites(pIdSociete) {
		let url = '';
		if (pIdSociete == '' || typeof pIdSociete === 'undefined' || pIdSociete == '0') url = `${__configuration.apiUrl}/massia/sites/headers/`;
		else url = `${__configuration.apiUrl}/massia/sites/header/${pIdSociete}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getSitesCom(pIdSociete) {
		let url = '';
		if (pIdSociete == null || pIdSociete == '' || typeof pIdSociete === 'undefined' || pIdSociete == '0')
			url = `${__configuration.apiUrl}/massia/sites-commerciaux/headers/`;
		else url = `${__configuration.apiUrl}/massia/sites-commerciaux/header/${pIdSociete}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getClientsFournisseurs(idSociete) {
		if (idSociete == '' || typeof idSociete === 'undefined' || idSociete == '0') {
			return null;
		} else {
			let url = `${__configuration.apiUrl}/massia/_form/site/${idSociete}/clients-fournisseurs`;
			let res = await this.$http.get(url);
			return res.data;
		}
	}

	async getClients(idSociete) {
		if (idSociete == '' || typeof idSociete === 'undefined' || idSociete == '0') {
			let url = `${__configuration.apiUrl}/massia/sites-clients`;
			let res = await this.$http.get(url);
			return res.data.items;
		} else {
			let url = `${__configuration.apiUrl}/massia/sites-clients/header/${idSociete}`;
			let res = await this.$http.get(url);
			return res.data;
		}
	}

	async getBennes(Id) {
		if (Id == '' || typeof Id === 'undefined' || Id == '0') {
			let url = `${__configuration.apiUrl}/massia/gestion/bennes`;
			let res = await this.$http.get(url);
			return res.data.items;
		} else {
			let url = `${__configuration.apiUrl}/massia/gestion/bennes/lite/${Id}`;
			let res = await this.$http.get(url);
			return res.data;
		}
	}

	async getTracteurs() {
		let url = `${__configuration.apiUrl}/massia/gestion/tracteurs/lite`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getVehicules(idTransporteur) {
		if (idTransporteur == '' || typeof idTransporteur === 'undefined' || idTransporteur == '0') {
			let url = `${__configuration.apiUrl}/massia/vehicules`;
			let res = await this.$http.get(url);
			return res.data.items;
		} else {
			let url = `${__configuration.apiUrl}/massia/vehicules/lite/${idTransporteur}`;
			let res = await this.$http.get(url);
			return res.data;
		}
	}

	async getTransporteurs(idSiteCommercial) {
		let url = '';
		if (idSiteCommercial == '' || typeof idSiteCommercial === 'undefined' || idSiteCommercial == '0')
			url = `${__configuration.apiUrl}/massia/sites-transporteurs/all`;
		else url = `${__configuration.apiUrl}/massia/sites-transporteurs/typeAheadCompteOuvertSiteComm/${idSiteCommercial}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getSitesTransporteur(pIdSociete) {
		let url = '';
		if (pIdSociete == '' || typeof pIdSociete === 'undefined' || pIdSociete == '0')
			url = `${__configuration.apiUrl}/massia/sites-transporteurs/all`;
		else url = `${__configuration.apiUrl}/massia/sites-transporteurs/typeAheadCompteOuvertSociete/${pIdSociete}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getChauffeurs(siteTransporteurId) {
		let url = `${__configuration.apiUrl}/massia/personnes/chauffeurs`;
		let params = {
			societeId: 0,
			siteTransporteurId: Number(siteTransporteurId) === -1 ? null : Number(siteTransporteurId),
			withFiltres: false
		};

		try {
			let res = await this.$http.get(url, { params: params });
			return res.data;
		} catch (error) {
			console.error('Chauffeurs:', error);
			throw error;
		}
	}

	async getFournisseurs(idSiteCommercial) {
		let url = '';
		if (idSiteCommercial == '' || typeof idSiteCommercial === 'undefined' || idSiteCommercial == '0')
			url = `${__configuration.apiUrl}/massia/sites-fournisseurs/all`;
		else url = `${__configuration.apiUrl}/massia/sites-fournisseurs/typeAhead-by-site/gestion/${idSiteCommercial}/all`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getProvenances(idFournisseur, dateActif) {
		let items = [];
		if (idFournisseur == '' || typeof idFournisseur === 'undefined' || idFournisseur == '0') {
			let url = `${__configuration.apiUrl}/massia/chantiers`;
			let res = await this.$http.get(url);
			items = res.data.items;
		} else {
			let url = `${__configuration.apiUrl}/massia/chantiers/headersByClient/${idFournisseur}`;
			let res = await this.$http.get(url);
			items = res.data;
		}
		if (dateActif) {
			const date = this.moment(dateActif, 'DD/MM/YYYY');
			if (!date.isValid) return items;

			const result = items.filter((c) => {
				if (c.dateDebut && c.dateFin) {
					const dateDebut = this.moment(c.dateDebut, 'YYYY-MM-DD');
					const dateFin = this.moment(c.dateFin, 'YYYY-MM-DD');
					return date.isBetween(dateDebut, dateFin, 'day', '[]');
				} else if (c.dateDebut) {
					const dateDebut = this.moment(c.dateDebut, 'YYYY-MM-DD');
					return date.isSameOrAfter(dateDebut, 'day');
				} else if (c.dateFin) {
					const dateFin = this.moment(c.dateFin, 'YYYY-MM-DD');
					return date.isSameOrBefore(dateFin, 'day');
				} else {
					return true;
				}
			});
			return result;
		} else {
			return items;
		}
	}

	async getDestinationBySiteComm(idSiteComm) {
		if (idSiteComm == '' || typeof idSiteComm === 'undefined' || idSiteComm == '0') {
			let url = `${__configuration.apiUrl}/massia/lieux`;
			let res = await this.$http.get(url);
			return res.data.items;
		} else {
			let url = `${__configuration.apiUrl}/massia/lieux/by-siteComm/${idSiteComm}`;
			let res = await this.$http.get(url);
			return res.data;
		}
	}

	async getDestinationByChantierOrSociete(idChantier, idSociete) {
		idChantier = idChantier === null || idChantier === '' ? 0 : idChantier;
		idSociete = idSociete === null || idSociete === '' ? 0 : idSociete;
		let url = `${__configuration.apiUrl}/massia/lieux/by-chantier-or-societe/${idChantier}/${idSociete}`;
		let res = await this.$http.get(url);
		return res.data;
	}

	async getCommandes(idProvenance, idSociete) {
		// on filtre les commandes par chantier et active et avec au moins un produit du meme sitecom dans la commande
		if (idProvenance && idProvenance != '0' && idSociete && idSociete != '0') {
			let url = `${__configuration.apiUrl}/massia/commandes/forOrdreTransport/${idProvenance}/${idSociete}`;
			let res = await this.$http.get(url);
			return res.data;
		} else if (idProvenance && idProvenance != '0') {
			let url = `${__configuration.apiUrl}/massia/commandes/headerByClient/${idProvenance}/all`;
			let res = await this.$http.get(url);
			return res.data;
		} else {
			let url = `${__configuration.apiUrl}/massia/commandes`;
			let res = await this.$http.get(url);
			return res.data.items;
		}
	}

	async getProduits(idSiteCommercial, sens, clientId) {
		// Détermine le segment de route selon le sens
		// sens = 0 → entrée
		// sens = 1 → sortie

		const type = sens == '1' ? 'sortie' : 'entree';

		const idSite = !idSiteCommercial || idSiteCommercial == '0' ? 0 : idSiteCommercial;
		const url = `${__configuration.apiUrl}/massia/_form/produits/${idSite}/${type}?clientId=${clientId || 0}`;
		console.log('🔥 - MassiaSelectService - getProduits - url:', url);

		// Envoie la requête HTTP
		const res = await this.$http.get(url);

		// Retourne les données du serveur
		return res.data;
	}

	//headerByClient/{idClient}/{valeur}
}
